var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "personal-inquiry-page" }, [
    _c("div", { staticClass: "panel-group" }, [
      _c("div", { staticClass: "panel cargo-info" }, [
        _c("h3", { staticClass: "panel-header" }, [_vm._v("货物信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-body" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("label", { staticClass: "label" }, [_vm._v("货物名称：")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inquiryOrder.goodsName,
                  expression: "inquiryOrder.goodsName"
                }
              ],
              staticClass: "input",
              attrs: { type: "text", placeholder: "请输入货物名称" },
              domProps: { value: _vm.inquiryOrder.goodsName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inquiryOrder, "goodsName", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group has-radio" }, [
            _c("label", { staticClass: "label" }, [_vm._v("货物重量：")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inquiryOrder.goodsCount,
                  expression: "inquiryOrder.goodsCount"
                }
              ],
              staticClass: "input",
              attrs: { type: "number", placeholder: "请输入货物重量" },
              domProps: { value: _vm.inquiryOrder.goodsCount },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inquiryOrder, "goodsCount", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "radio-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inquiryOrder.unit,
                    expression: "inquiryOrder.unit"
                  }
                ],
                staticClass: "radio",
                attrs: {
                  type: "radio",
                  value: "吨",
                  name: "unit",
                  id: "unit-dun"
                },
                domProps: { checked: _vm._q(_vm.inquiryOrder.unit, "吨") },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.inquiryOrder, "unit", "吨")
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "unit-dun" } }, [_vm._v("吨")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "radio-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inquiryOrder.unit,
                    expression: "inquiryOrder.unit"
                  }
                ],
                staticClass: "radio",
                attrs: {
                  type: "radio",
                  value: "方",
                  name: "unit",
                  id: "unit-fang"
                },
                domProps: { checked: _vm._q(_vm.inquiryOrder.unit, "方") },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.inquiryOrder, "unit", "方")
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "unit-fang" } }, [_vm._v("方")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group" }, [
            _c("label", { staticClass: "label" }, [_vm._v("货主姓名：")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inquiryOrder.name,
                  expression: "inquiryOrder.name"
                }
              ],
              staticClass: "input",
              attrs: { type: "text", placeholder: "请输入货主姓名" },
              domProps: { value: _vm.inquiryOrder.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inquiryOrder, "name", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group" }, [
            _c("label", { staticClass: "label" }, [_vm._v("电话号码：")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inquiryOrder.phone,
                  expression: "inquiryOrder.phone"
                }
              ],
              staticClass: "input",
              attrs: { type: "number", placeholder: "请输入电话号码" },
              domProps: { value: _vm.inquiryOrder.phone },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inquiryOrder, "phone", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("提货地址：")]),
              _vm._v(" "),
              _c("v-distpicker", {
                on: {
                  province: _vm.fromProvinceHandler,
                  city: _vm.fromCityHandler,
                  area: _vm.fromAreaHandler
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("label", { staticClass: "label" }, [_vm._v("送达地址：")]),
              _vm._v(" "),
              _c("v-distpicker", {
                on: {
                  province: _vm.toProvinceHandler,
                  city: _vm.toCityHandler,
                  area: _vm.toAreaHandler
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-primary inquiry-btn",
        on: { click: _vm.inquiryHandler }
      },
      [_vm._v("立即询价")]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel inquiry-info" }, [
      _c("h3", { staticClass: "panel-header" }, [_vm._v("发货信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-body" }, [
        _c("span", [_vm._v("是否货到付款：")]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-group" }, [
          _c("input", {
            staticClass: "radio",
            attrs: {
              type: "radio",
              value: "是",
              name: "huodaofukuan",
              id: "huodaofukuan-yes"
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "huodaofukuan-yes" } }, [_vm._v("是")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-group" }, [
          _c("input", {
            staticClass: "radio",
            attrs: {
              type: "radio",
              value: "否",
              name: "huodaofukuan",
              id: "huodaofukuan-no"
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "huodaofukuan-no" } }, [_vm._v("否")])
        ]),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c("span", [_vm._v("是否需要发票：")]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-group" }, [
          _c("input", {
            staticClass: "radio",
            attrs: {
              type: "radio",
              value: "是",
              name: "fapiao",
              id: "fapiao-yes"
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "fapiao-yes" } }, [_vm._v("是")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-group" }, [
          _c("input", {
            staticClass: "radio",
            attrs: {
              type: "radio",
              value: "否",
              name: "fapiao",
              id: "fapiao-no"
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "fapiao-no" } }, [_vm._v("否")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c1a1e5dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c1a1e5dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/inquiry.vue
// module id = null
// module chunks = 